var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is_deactivated)?_c('button',{staticClass:"gray",on:{"click":_vm.activateAccount}},[_vm._v("Activate")]):_c('button',{staticClass:"gray",on:{"click":_vm.deactivateAccount}},[_vm._v("Deactivate Account")])])}
var staticRenderFns = []

export { render, staticRenderFns }